// extracted by mini-css-extract-plugin
export default {"emptyMessage":"emptyMessage_emptyMessage__VPEsA","image":"emptyMessage_image__c-tR4","content":"emptyMessage_content__3ckGE","vertical":"emptyMessage_vertical__bXmwq"};